import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const POINTS = [
  'Cookies httpOnly para sesión, control de permisos y endurecimiento progresivo del acceso.',
  'Contratos, pagos, consentimientos y eventos sensibles con trazabilidad y auditoría.',
  'Revisión humana, transparencia IA y límites operativos cuando una acción puede tener impacto alto.',
  'Conexiones externas gestionadas con separación clara entre experiencia pública y operativa interna.',
];

export default function SecurityPage() {
  return (
    <>
      <SEO title="Seguridad | Neuralia369" description="Cómo Neuralia369 aborda permisos, auditoría, seguridad operativa y transparencia." path="/seguridad" />
      <main className="min-h-screen bg-background px-4 py-16 sm:px-6 lg:px-8" data-testid="security-page">
        <div className="mx-auto max-w-5xl">
          <motion.section initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} className="glass-card tracing-panel p-8 md:p-10" data-testid="security-card">
            <p className="editorial-kicker mb-4">Seguridad y confianza</p>
            <h1 className="text-4xl sm:text-5xl text-text-heading">Más control, menos improvisación.</h1>
            <p className="mt-4 max-w-3xl text-lg text-text-body">Neuralia369 está diseñada para combinar velocidad operativa con límites claros: acceso controlado, rastreo de eventos y supervisión humana cuando hace falta.</p>
            <div className="mt-8 space-y-3" data-testid="security-points-list">
              {POINTS.map((item, index) => <div key={item} className="rounded-[22px] border border-border-subtle bg-background/55 p-4 text-sm text-text-body" data-testid={`security-point-${index}`}>{item}</div>)}
            </div>
          </motion.section>
        </div>
      </main>
    </>
  );
}